import {Component, OnInit} from '@angular/core';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {DocumentationService} from '@services/support/documentation.service';
import {NotificationService} from '@services/notification/notification.service';

@Component({
    selector: 'scitis-support-documentation',
    templateUrl: './support-documentation.component.html',
    styleUrls: ['./support-documentation.component.scss'],
    standalone: false
})
export class SupportDocumentationComponent implements OnInit {

  isLoading: boolean = true;
  closeButtonText: string = '';
  fallbackText: string = '';
  documentations: string[] = [];

  private COMPONENT_NAME: string = 'SupportDocumentationComponent';

  constructor(private activeModal: NgbActiveModal,
              private translateService: TranslateService,
              private documentationService: DocumentationService,
              private notificationService: NotificationService) {
    this.closeButtonText = this.translateService.instant('Close');
    this.fallbackText = this.translateService.instant('No documentation file(s) have been added yet. Please check your organisation\'s settings or contact your administrator.');
  }

  ngOnInit() {
    this.loadDocumentations();
  }

  onClose() {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  onDownloadDocumentation(docName: string) {
    const requestDocName = docName.replaceAll('/', '%2F');
    this.documentationService.downloadDocumentation(requestDocName).subscribe((download) => {
      const blob = new Blob([download], {type: 'application/pdf'});
      const fileURL = URL.createObjectURL(blob);
      const hiddenElement = document.createElement('a');
      hiddenElement.href = fileURL;
      hiddenElement.download = docName;
      hiddenElement.click();
      window.URL.revokeObjectURL(fileURL);
      hiddenElement.remove();
    }, (error) => {
      let errorMessage: string = this.translateService.instant('Could not download document %doc');
      errorMessage = errorMessage.replaceAll('%doc', docName.toBold());
      this.notificationService.error(errorMessage, error, this.COMPONENT_NAME, true);
    });
  }

  get showFallBackText(): boolean {
    return !this.isLoading && (!this.documentations || this.documentations.length === 0);
  }

  private loadDocumentations() {
    this.documentationService.getDocumentations().subscribe((docs) => {
      this.documentations = docs;
      this.isLoading = false;
    }, (error) => {
      this.isLoading = false;
      console.log('No documentations found', error);
    });
  }

}
